/**
 * Kazakh translations — partial coverage.
 * Missing keys fall back to Russian via t() in src/locales/translate.ts.
 * TODO: Complete kk.ts after localization review.
 */
import type { TranslationDictionary } from './types';

export const kk: TranslationDictionary = {
  nav: {
    dashboard: 'Басқару панелі',
    users: 'Пайдаланушылар',
    logs: 'Журналдар',
    staff: 'Қызметкерлер',
  },
  sidebar: {
    brandSubtitle: 'Әкімшілік панелі',
    mainNavigation: 'Негізгі навигация',
  },
  topBar: {
    administration: 'Әкімшілік',
    adminFallback: 'Әкімші',
  },
  auth: {
    accessDenied: {
      title: 'Қол жеткізу тыйым салынған',
      subtitle: 'Unit 1 Admin Web осы бөліміне қол жеткізуіңіз жоқ.',
      backToDashboard: 'Басқару панеліне оралу',
    },
  },
  login: {
    title: 'Unit 1 Admin',
    subtitle: 'Жалғастыру үшін кіріңіз',
  },
};
